import React, { Component } from 'react';
import { map, startsWith, split } from 'lodash';
import PT from 'prop-types';
import { Card, Slider, getBreakpointForContainer, RESPONSIVE_BREAKPOINTS, BREAKPOINT_NAMES_ENUM } from '../toolkit';
import { ShowMoreItems } from './showmoreitems';
import { buildProductImage, concatUrl } from '../util';
import cIf from "classnames";

export class CardsSection extends Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();

        this.state = {
            breakpoint: BREAKPOINT_NAMES_ENUM.LARGE_SCREEN,
            width: null,
            display: true,
            isDraggingSlider: false
        };

        this.setBreakpointForThisPage = this.setBreakpointForThisPage.bind(this);
    }

    componentDidMount() {
        this.setBreakpointForThisPage();
        window.addEventListener("resize", this.setBreakpointForThisPage, false);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.setBreakpointForThisPage, false);
    }

    setBreakpointForThisPage() {
        const curBreakpoint = getBreakpointForContainer(this.containerRef, RESPONSIVE_BREAKPOINTS);

        if(this.state.breakpoint !== curBreakpoint || this.state.width !== this.containerRef.current.clientWidth) 
            this.setState({ breakpoint: curBreakpoint, width: this.containerRef.current.clientWidth, display: false }, () => this.setState({ display: true }));
    }

    buildProductActionUrl(product) {
        let finalActionUrl = "";

        if (startsWith(product.actionUrl, 'http')) {
            finalActionUrl = product.actionUrl;
        } else if (startsWith(product.actionUrl, '?')) {
            finalActionUrl = concatUrl(this.props.homeUrl, product.actionUrl);
        } else {
            const [productType, productId] = split(product.actionUrl, '://');
            finalActionUrl = concatUrl(this.props.homeUrl, `${productType}/${productId}`);
        }
        return finalActionUrl;
    }

    onSliderDragged(dragging) {
        this.setState({isDraggingSlider: dragging});
    }

    render() {
        let allCards = null, cardsContainer = null;
        const _this = this;

        allCards = map(this.props.cards, function (card, i) {
            const isWide = card.isTopiCard && card.isWide && this.state.breakpoint !== BREAKPOINT_NAMES_ENUM.MOBILE; 

            const { productImageUrl, isProductImage } = buildProductImage(this.props.homeUrl, card, isWide);
            const cardActionUrl = _this.buildProductActionUrl(card);

            let flag = null; 
            
            if(card.isCancelled) {
                flag = {
                    label: _this.props.tr("Annulé"),
                    type: "warning"
                };
            }
            else if(card.isSoldOut) {
                flag = {
                    label: _this.props.tr("Complet"),
                    type: "warning"
                };
            }

            const buttonTitle = !card.isCancelled && !card.isSoldOut ? _this.props.tr("Acheter") : _this.props.tr("En savoir plus");
            return (
                <Card
                    key={i}
                    cardActionUrl={cardActionUrl}
                    isWide={isWide}
                    title={card.title}
                    subtitle={card.subtitle}
                    details={card.details}
                    hasInfoDetails={card.hasInfoDetails}
                    buttonTitle={buttonTitle}
                    isEventOrPackage={true}
                    productImageUrl={productImageUrl}
                    isProductImage={isProductImage}
                    isDraggingSlider={this.state.isDraggingSlider}
                    flag={flag}
                />
            );
        }.bind(this));

        if (!this.props.displayAsGrid)
            cardsContainer = <Slider 
                products={allCards}
                width={this.state.width}
                breakpoint={this.state.breakpoint}
                display={this.state.display}
                onDrag={this.onSliderDragged.bind(this)}
            />;
        else    
            cardsContainer = <ShowMoreItems 
                items={allCards}
                range={15}
                width={this.state.width}
                breakpoint={this.state.breakpoint}
                buttonTitle={this.props.tr("Afficher plus")} 
            />;

        return <div className={cIf("row-content", { slider: !this.props.displayAsGrid })}>
            <div ref={this.containerRef}>
                <h2>{this.props.title}</h2>
                {cardsContainer}
            </div>
        </div>;
    }
}
CardsSection.propTypes = {
    cards: PT.array, // UITopicCard
    tr: PT.func,
    displayAsGrid: PT.bool,
    title: PT.string,
    homeUrl: PT.string
};
CardsSection.defaultProps = {
    displayAsGrid: false
};
